module.exports = __webpack_public_path__ + "account/img/31.20dcdceb.png";